import { useEffect, useState } from "react";
import { fetchFriends } from "./Api";
import ProfileModal from "./ProfileModal";

const FriendList = ({ title = "MY FRIENDS" }) => {

  const [friends, setFriends] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedFriendId, setSelectedFriendId] = useState(null);

  useEffect(() => {
    const loadFriends = async () => {
      try {
        setLoading(true);
        const data = await fetchFriends("accepted");
        setFriends(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("Failed to fetch friends:", err);
        setFriends([]);
      } finally {
        setLoading(false);
      }
    };

    loadFriends();
  }, []);

  return (
    <div>
      <h2 style={{ 
        margin: 0,
          fontSize: '20px',
          fontWeight: '700',
          fontStyle: 'bolder',
          color: '#740A03',
          fontFamily: 'Arial, sans-serif',
        }}>{title}</h2>
      {loading ? (
        <p>Loading friends...</p>
      ) : friends.length === 0 ? (
        <p>No friends to show.</p>
      ) : (

        <ul style={{ 
          listStyle: "none", 
          padding: 0, 
          margin: 0, 
          fontFamily: 'Arial, sans-serif', 
          color: '#740A03' }}>
          {friends.map((friend) => (
            <li
              key={friend.id}
              style={{ padding: "8px 0", cursor: "pointer" }}
              onClick={() => setSelectedFriendId(friend.id)}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                {friend.profile_image ? (
                  <img
                    src={friend.profile_image ? `${friend.profile_image}?t=${Date.now()}` : `https://ui-avatars.com/api/?name=${encodeURIComponent(friend.full_name || "Friend")}&size=120&background=ddd&color=555&t=${Date.now()}`}
                    alt={friend.full_name || friend.email || "Unnamed User"}
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50px",
                      objectFit: "cover",

                    }}
                  />
                ) : (
                  <span
                    style={{
                      width: "40px",
                      height: "40px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "40px",
                      lineHeight: "1",
                    }}
                  >
                    👤
                  </span>
                )}

                <span style={{ marginLeft: "20px" }}>
                  {friend.full_name || "Unnamed User"}
                </span>
              </div>

            </li>
          ))}
        </ul>


      )}

      {selectedFriendId && (
        <ProfileModal
          userId={selectedFriendId}
          onClose={() => setSelectedFriendId(null)}
        />
      )}
    </div>
  );
};

export default FriendList;
